import React from 'react';

import orderBy from 'lodash.orderby';
import { useFormContext } from 'react-hook-form';

import { FormField } from '@/_components';
import { useBoolean } from '@/_shared';

import { PreviewEmails } from './components';
import { EditEmails } from './components/edit';

function EmailFormBase({ isEditable }: { isEditable?: boolean }) {
  const { current: form } = React.useRef(useFormContext());
  const [open, setOpen] = useBoolean();

  return (
    <FormField
      control={form.control}
      name="emails"
      render={({ field: { value, onChange } }) => {
        const sortedValue = orderBy(value, (item) => item?.pivot?.default ?? 0, 'desc');
        return (
          <>
            {isEditable && open && (
              <EditEmails open={open} onClose={setOpen.setFalse} value={sortedValue} onChange={onChange} />
            )}
            <PreviewEmails value={sortedValue} onOpen={setOpen.setTrue} isEditable={isEditable} />
          </>
        );
      }}
    />
  );
}

export const EmailsForm = React.memo(EmailFormBase);
